export default __webpack_public_path__ + "static/media/Pistol_6.e1ef9b96.png";